/* global localStorage */

import HttpRequest from './core/http_request';
import { saveSession, clearSession } from './core/auth_session';

class AuthProvider extends HttpRequest {
  loginByEmail (data) {
    return this.request('POST', '/public/auth/loginByEmail', data).then(response => {
      if (response?.data?.token?.accessToken) {
        saveSession(response.data);
      }
      return response;
    });
  }

  loginByLine (data) {
    return this.request('POST', '/public/auth/loginByLine', data).then(response => {
      if (response?.data?.token?.accessToken) {
        saveSession(response.data);
      }
      return response;
    });
  }

  logout () {
    clearSession();
  }

  refreshToken (data) {
    return this.request('POST', '/public/auth/refreshToken', data);
  }

  requestOTP (data) {
    return this.request('POST', '/public/auth/requestOtp', data);
  }

  validateOTPLogin (data) {
    return this.request('POST', '/public/auth/validateOtp', data).then(response => {
      if (response?.data?.token?.accessToken) {
        saveSession(response.data);
      }
      return response;
    });
  }

  register (data) {
    return this.request('POST', '/public/auth/register', data).then(response => {
      if (response?.data?.token?.accessToken) {
        saveSession(response.data);
      }
      return response;
    });
  }

  registerWithLine (data) {
    return this.request('POST', '/public/auth/registerWithLine', data).then(response => {
      if (response?.data?.token?.accessToken) {
        saveSession(response.data);
      }
      return response;
    });
  }

  linkWithCsite (data) {
    return this.request('POST', '/public/auth/linkWithCsite', data).then(response => {
      if (response?.data?.token?.accessToken) {
        saveSession(response.data);
      }
      return response;
    });
  }

  linkWithLine (data) {
    return this.request('POST', '/public/auth/linkWithLine', data).then(response => {
      if (response?.data?.token?.accessToken) {
        saveSession(response.data);
      }
      return response;
    });
  }

  emailVerification (data) {
    return this.request('POST', '/public/auth/emailVerification', data);
  }

  updatePassword (data) {
    return this.request('POST', '/public/auth/updatePass', data);
  }

  requestForgetPassword (data) {
    return this.request('POST', '/public/auth/forgetPassword', data);
  }

  verifyForgetPasswordToken (data) {
    return this.request('get', '/public/auth/forgetPassEmail', data);
  }
}

export default AuthProvider;
